import { Badge } from 'cpool-components/general/Badge';
import { COLORS } from 'cpool-components/types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { SchemaCreditRequestForm } from '../schemas/creditRequestForm.schema';
import { currencyFormat, numberFormat } from '~/lib/i18n';

type Props = {
    name: keyof SchemaCreditRequestForm;
    displayName: string;
    units?: string;
};

export const HeaderNotification: React.FC<Props> = ({ displayName, name, units }) => {
    const { t } = useTranslation();
    const data = useWatch({ name });

    const convertedData = () => {
        if (name === 'verwendungszweck') {
            return t(`FUNDING_TYPES.${data as NonNullable<SchemaCreditRequestForm['verwendungszweck']>}`);
        }
        if (name === 'ratenzahlungstermin') {
            return t(
                `BANK_CREDIT_REQUEST.PAYMENT_DATES.${
                    data as NonNullable<SchemaCreditRequestForm['ratenzahlungstermin']>
                }`,
            );
        }
        if (name === 'kreditBetrag') {
            return currencyFormat(data as number);
        }
        if (name === 'provision') {
            return numberFormat(data as number);
        }
        return data;
    };

    return (
        <Badge color={COLORS.WHITE}>
            {displayName}: {convertedData()} {units}
        </Badge>
    );
};
